<template>
    <div>
      <a href="#" @click.prevent="show" style="width:100%;">
          <img :src="thumbnail" id="thumbnail">
      </a>
      <div class="lightbox" v-if="visible" @click="hide" style="display:flex;justify-content:center;align-items:center;position:fixed;z-index:99999;width:100vw;height:100vh;top:0;left:0;">
          <div @click.stop="hide" style="position:absolute;color:white;font-size:30px;top:15px;right:40px;cursor:pointer;">&times;</div>
          <div style="display:flex;">
              <div @click.stop="prev" :class="{'invisible': ! hasPrev()}" class="lb-arrow">
                  <svg fill="#fff" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
                      <path d="M0-.5h24v24H0z" fill="none"/>
                  </svg>
              </div>
              <div class="lightbox-image" @click.stop="" style="position:relative;user-select:none;">
                  <img :src="images[index].fields.Image[0].url" style="margin:0 auto;display:block;">
                  <div class="product-gallery-row-title" style="position:absolute:bottom:0;width:100%;height:40x;background:#00C5BC;color:white;padding:10px 18px;user-select:none;">{{ name[index].fields.Product }}</div>
              </div>
              <div @click.stop="next" :class="{'invisible': ! hasNext()}" class="lb-arrow">
                  <svg fill="#fff" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/>
                      <path d="M0-.25h24v24H0z" fill="none"/>
                  </svg>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
    props: {
        thumbnail: {
            type: String,
            required: true,
        },
        images: {
            type: Array,
            default: () => [],
        },
        name: {
            type: Array,
            default: () => [],
        },
        num: {
            type: Number,
        }
    },
    data() {
        return {
            visible: false,
            index: this.num,
        };
    },
    methods: {
        aa(){
            console.log(this.index);
        },
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
            this.index = this.num;
        },
        hasNext() {
            return this.index + 1 < this.images.length;
        },
        hasPrev() {
            return this.index - 1 >= 0;
        },
        prev() {
            if (this.hasPrev()) {
                this.index -= 1;
            }
        },
        next() {
            if (this.hasNext()) {
                this.index += 1;
            }
        },
        onKeydown(e) {
            if (this.visible) {
                switch (e.key) {
                    case 'ArrowRight':
                        this.next();
                        break;
                    case 'ArrowLeft':
                        this.prev();
                        break;
                    case 'ArrowDown':
                    case 'ArrowUp':
                    case ' ':
                        e.preventDefault();
                        break;
                    case 'Escape':
                        this.hide();
                        break;
                }
            }
        },
    },
    mounted() {
        window.addEventListener('keydown', this.onKeydown)
    },
    destroyed() {
        window.removeEventListener('keydown', this.onKeydown)
    },
};
</script>

<style scoped>
.lightbox {
    background: rgba(0, 0, 0, 0.8);
}
.lightbox-image img {
    width: 45vw;
    height: 65vh;
    max-height: 65vh;
    object-fit: cover;
}
.lb-arrow {
    align-self:center;
    cursor:pointer;
    padding:10px 40px;
    user-select: none;
}
#thumbnail {
    width: 100%;
    /* height: auto; */
    object-fit: cover;
    min-height: 100%;
}
@media screen and (max-width: 500px) {
    .lightbox-image img {
        width: auto;
        height: auto;
        max-width: 62vw;
        max-height: calc(100vh - 90px);
    }
    .lb-arrow {
        align-self:center;
        cursor:pointer;
        padding:10px 10px;
    }
    /* #thumbnail {
        width: unset;
        height: unset;
    } */
}
</style>

